'use client';
import React from 'react';
import { ConfigProvider as AntdConfigProvider, ThemeConfig as AntdThemeConfig } from 'antd';
import styled, { ThemeContext } from './ThemeStyle';

export const BeeZ: React.FC<React.PropsWithChildren> = props => {
  const theme = React.useContext(ThemeContext);

  const antdTheme = React.useMemo<AntdThemeConfig>(() => {
    const fontSize = 12;
    const paddingMD = 12;
    const paddingSM = 9;
    return {
      components: {
        Radio: {
          buttonColor: theme.colors.foregroundActive,
          colorBgContainer: theme.colors.background,
          dotSize: 5,
          fontSize: 12,
        },
        Slider: {
          colorBgElevated: theme.colors.foreground,
          colorTextDescription: theme.colors.foreground,
          dotActiveBorderColor: theme.colors.brand,
          dotBorderColor: theme.colors.borderLight,
          handleActiveColor: theme.colors.foreground,
          handleColor: theme.colors.foreground,
          handleLineWidthHover: 2,
          handleSizeHover: 10,
          railBg: theme.colors.backgroundInactive,
          railHoverBg: theme.colors.borderLight,
          trackBg: theme.colors.brand,
          trackHoverBg: theme.colors.brand,
        },
        Switch: {
          colorTextQuaternary: theme.colors.backgroundInactive,
          colorWhite: theme.colors.background,
        },
        Tabs: {
          horizontalItemPadding: '9px 10px',
          horizontalItemPaddingSm: '8px 10px',
          itemSelectedColor: theme.colors.foreground,
          padding: 9,
          paddingSm: 8,
          paddingXS: 8,
        },
      },
      token: {
        borderRadius: 0,
        borderRadiusSM: 0,
        colorBgContainer: theme.colors.background,
        colorBgElevated: theme.colors.background,
        colorBorder: theme.colors.border,
        colorBorderSecondary: theme.colors.border,
        colorError: theme.colors.danger,
        colorHighlight: theme.colors.danger,
        colorIcon: theme.colors.foreground,
        colorInfo: theme.colors.information,
        colorPrimary: theme.colors.brand,
        colorSuccess: theme.colors.success,
        colorText: theme.colors.foreground,
        colorTextDisabled: theme.colors.foregroundMuted,
        colorTextHeading: theme.colors.foregroundActive,
        colorTextPlaceholder: theme.colors.foregroundMuted,
        colorTextSecondary: theme.colors.foreground,
        colorWarning: theme.colors.warning,
        controlItemBgActive: theme.colors.backgroundActive,
        controlItemBgHover: theme.colors.backgroundInactive,
        fontFamily: 'proxima-nova, helvetica, arial, sans-serif',
        fontSize,
        fontSizeLG: fontSize + 2,
        fontSizeSM: fontSize - 2,
        lineHeight: 1,
        paddingLG: 21,
        paddingMD,
        paddingSM,
        paddingXS: 6,
      },
    };
  }, [theme]);

  return (
    <AntdConfigProvider theme={antdTheme}>
      <AntdStyler>{props.children}</AntdStyler>
    </AntdConfigProvider>
  );
};

const AntdStyler = styled.div`
  height: 100%;
  color: ${props => props.theme.colors.foreground};

  //Radio
  .ant-radio {
    align-self: unset !important;
  }
  .ant-radio-group-small .ant-radio-button-wrapper {
    height: 24px !important;
    line-height: 22px !important;
    padding: 0 8px !important;
  }

  //Switch
  .ant-switch-handle {
    height: 18px !important;
    top: 2px !important;
    width: 18px !important;
  }
  .ant-switch-checked .ant-switch-handle {
    left: calc(100% - 20px) !important;
  }
  .ant-switch-handle::before {
    border-radius: 9px !important;
  }
  .ant-switch {
    height: 22px !important;
    min-width: 44px !important;
  }

  //Button
  .ant-btn-primary {
    box-shadow: none !important;
  }

  //Select
  .ant-select-selector {
    box-shadow: none !important;
  }
`;
